import { render } from "./hotelAnswer.vue?vue&type=template&id=5eeb274a&scoped=true"
import script from "./hotelAnswer.vue?vue&type=script&lang=js"
export * from "./hotelAnswer.vue?vue&type=script&lang=js"

import "./hotelAnswer.vue?vue&type=style&index=0&id=5eeb274a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eeb274a"]])

export default __exports__